import React from "react";
import { Redirect, useParams } from "react-router-dom";

function ConversationListRedirect() {
  const { subUserId } = useParams<{ subUserId: string }>();

  return <Redirect to={`/aicc/customer/subusers/${subUserId}`} />;
}

export default ConversationListRedirect;
